import { storage } from 'base/utils/localStorage';
import { STORAGE_REFERRAL, CODE_VALID_DURATION } from 'mod/referral/constant';
import { scrollToAnchor } from 'base/utils/scrollTo'

function excludeExpired(data: Record<string, number>): Record<string, number> {
    const _data = {};
    const curTime = (new Date()).getTime();
    Object.entries(data).forEach(([code, time]) => {
        if (curTime - time < CODE_VALID_DURATION) {
            _data[code] = time;
        }
    });
    return data;
}

function getSortedCodes(obj: Record<string, number>): string[] {
    const timeCodeMap = {} as Record<number, string>;
    const times = [] as number[];
    Object.entries(obj).forEach(([code, time]) => {
        times.push(time);
        timeCodeMap[time] = code;
    });
    return times.sort((a, b) => b - a).map(time => timeCodeMap[time]);
}

export function storeReferralCode(code: string) {
    const str = storage.get(STORAGE_REFERRAL);
    const data = str ? excludeExpired(JSON.parse(str)) : {};
    data[code] = (new Date()).getTime();
    storage.set(STORAGE_REFERRAL, JSON.stringify(data))
}

export function getStoredReferralCodes(): string[] {
    const str = storage.get(STORAGE_REFERRAL);
    if (!str) {
        return [];
    }
    const data = excludeExpired(JSON.parse(str));
    return getSortedCodes(data);
}

/**
 * 滚动至分享按钮 模拟点击弹窗弹框
 */
export const goScrollAndShare = () => {
    const el = document.getElementById('js-share-btn')
    scrollToAnchor({
        selector: el || '#js-share-btn'
    })
    // 点击弹窗分享弹框
    el?.click();
}